import { render, staticRenderFns } from "./Yarnboard3.vue?vue&type=template&id=a3bfc57a&scoped=true&"
import script from "./Yarnboard3.vue?vue&type=script&lang=js&"
export * from "./Yarnboard3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bfc57a",
  null
  
)

export default component.exports